export default __webpack_public_path__ + "static/media/HP6.f5db20a2.jpg";